module.exports = __webpack_public_path__ + "img/pending-joint.ddf92daa.svg";